import { useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
// import { CustomFieldData } from "./regFormTypes.ts";

export const FormControl = ({
  inputType,
  fieldName,
  deleteCustomField,
  label,
  width,
  _id,
  setOpen,
  setIsEdit,
  options = [],
  config = {},
}) => {
  const { register, setValue } = useFormContext();
  const [multiSelect, setMultiSelect] = useState(false);
  const [multiplValue, setMultiplValue] = useState([]);

  switch (inputType) {
    case "text":
      return (
        <div className="flex items-center justify-between mb-[30px] ">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div className="relative mt-[-20px]">
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <input
              type="text"
              id={fieldName}
              className={`${
                width ? `w-[${width}]` : "w-[300px]"
              } peer bg-white border border-gray-300 text-gray-900 text-[12px] rounded-lg h-[35px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
              // placeholder={label}
              {...register(fieldName, config)}
            />
          </div>

          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "phoneNumber":
      return (
        <div className="flex items-center justify-between mb-[30px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div className="relative mt-[-20px]">
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <input
              type="tel"
              id={fieldName}
              className={`${
                width ? `w-[${width}]` : "w-[300px]"
              } peer bg-white border border-gray-300 text-gray-900 text-[12px] rounded-lg h-[35px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
              // placeholder={label}
              {...register(fieldName, { ...config })}
              pattern="[6-9]\d{9}"
            />
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType
                  .replace(/([a-z])([A-Z])/g, "$1 $2")
                  .replace(/^./, (match) => match.toUpperCase())
                  .replace(
                    /([^\s]+)/g,
                    (match) => match.charAt(0).toUpperCase() + match.slice(1)
                  ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "email":
      return (
        <div className="flex items-center justify-between mb-[30px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div className="relative mt-[-20px]">
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <input
              type="email"
              id={fieldName}
              className={`${
                width ? `w-[${width}]` : "w-[300px]"
              } peer bg-white border border-gray-300 text-gray-900 text-[12px] rounded-lg h-[35px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
              // placeholder={label}
              {...register(fieldName, config)}
            />
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "url":
      return (
        <div className="flex items-center justify-between mb-[30px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div className="relative mt-[-20px]">
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <input
              type="url"
              id={fieldName}
              className={`${
                width ? `w-[${width}]` : "w-[300px]"
              } peer bg-white border border-gray-300 text-gray-900 text-[12px] rounded-lg h-[35px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
              // placeholder={label}
              {...register(fieldName, config)}
            />
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "select": {
      return (
        <div className=" flex mb-[30px] items-center w-[400px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div
            className={`${
              width ? `w-[${width}]` : "w-[300px]"
            } relative mt-[-20px]`}
          >
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <select
              id={fieldName}
              name={fieldName}
              {...register(fieldName, config)}
              className={`${
                width ? `w-[${width}]` : "w-[300px]"
              } peer bg-white border border-gray-300 text-gray-900 text-[11px] rounded-lg h-[35px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px] block px-2.5 py-0 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
            >
              {options.map((o, index) => (
                <option key={index} value={o.value} className="text-[14px]">
                  {o.label}
                </option>
              ))}
            </select>
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options.map((obj) => obj.value).join(","),
              });
              setOpen(true);
            }}
          />
        </div>
      );
    }
    case "multi-select": {
      return (
        <div className=" flex mb-[30px] items-center w-[400px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div
            className={`${
              width ? `w-[${width}]` : "w-[300px]"
            } relative mt-[-20px]`}
          >
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <div
              className="selected-options flex flex-wrap items-center gap-2   min-w-[8rem] min-h-[35px] bg-white border border-gray-300 text-gray-900 text-[12px] rounded-lg placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px]  p-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500"
              onClick={() => setMultiSelect(!multiSelect)}
            >
              {multiplValue.map((option) => (
                <div
                  key={option._id}
                  className="flex items-center bg-white border text-gray-700 rounded px-2 py-0 m-0 text-[14px] h-[25px]  "
                >
                  {option.label}
                  <button
                    type="button"
                    onClick={() => {
                      const updatedVal = multiplValue.filter(
                        (value) => value._id !== option._id
                      );
                      setValue(fieldName, multiplValue);
                      setMultiplValue(updatedVal);
                    }}
                    className="ml-2 bg-transparent border-none text-gray-700 text-xl cursor-pointer"
                  >
                    <img src="/svgs/Cross.svg" alt="cross" />
                  </button>
                </div>
              ))}
            </div>

            {multiSelect && (
              <div className="relative ">
                <select
                  multiple={true}
                  {...register(fieldName, config)}
                  id={fieldName}
                  name={fieldName}
                  // onChange={() => setValue(fieldName, multiplValue)}
                  className="appearance-none absolute top-full left-0 right-0 z-10 w-full  overflow-y-auto bg-white border border-gray-400 rounded p-1 text-[14px] h-[75px] "
                >
                  {options.map((option) => (
                    <option
                      key={option.id}
                      value={option.id}
                      disabled={multiplValue.includes(option)}
                      className="py- px-2 cursor-pointer hover:bg-gray-200"
                      onClick={() => {
                        setMultiplValue([...multiplValue, option]);
                        setMultiSelect(false);
                        setValue(fieldName, [...multiplValue, option]);
                      }}
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType
                  .replace(/-/g, " ")
                  .replace(/\b\w/g, (match) => match.toUpperCase()),
                options: options.map((obj) => obj.value).join(","),
              });
              setOpen(true);
            }}
          />
        </div>
      );
    }
    case "number":
      return (
        <div className="flex items-center justify-between mb-[30px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div className="relative mt-[-20px]">
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <input
              type="number"
              id={fieldName}
              className={`${
                width ? `w-[${width}]` : "w-[300px]"
              } peer bg-white border border-gray-300 text-gray-900 text-[12px] rounded-lg h-[35px] placeholder-transparent focus:ring-transparent focus:border-primary focus:border-[1.2px] block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white font-medium dark:focus:ring-blue-500 dark:focus:border-blue-500`}
              // placeholder={label}
              {...register(fieldName, config)}
            />
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "checkbox":
      return (
        <div className="flex">
          <div className="flex items-center justify-start mb-[30px] ">
            <img
              src="/svgs/Menu.svg"
              alt="menu"
              className="w-6 h-6 mx-2 cursor-move"
            />
            <div className="text-[13px] font-[500] text-primary w-[300px] ">
              <input
                type="checkbox"
                id={fieldName}
                className="mr-2 border border-[#cacaca] bg-white checked:bg-primary checked:border-[#EBEEF2] cursor-pointer focus:ring-0 "
                // checked
                {...register(fieldName, config)}
              />
              <label
                htmlFor={fieldName}
                className="inline-block ml-[0px] text-[#a0a0a0] cursor-pointer"
              >
                {label}
              </label>
            </div>
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "file":
      return (
        <div className="flex items-center justify-between mb-[30px]">
          <img
            src="/svgs/Menu.svg"
            alt="menu"
            className="w-6 h-6 mx-2 cursor-move"
          />
          <div className="relative w-[280px] mt-[-20px]">
            <label
              htmlFor={fieldName}
              className="inline-block pl-2 left-2 -top-5 mb-1 text-sm peer-placeholder-shown:text-sm peer-placeholder-shown:text-gray-900 peer-placeholder-shown:text-opacity-40 peer-placeholder-shown:top-[10px] peer-placeholder-shown:left-[13px] transition-all peer-focus:-top-5 peer-focus:text-gray-900 peer-focus:text-opacity-40 peer-focus:text-[12.5px] font-medium text-gray-900 text-opacity-40 dark:text-gray-300"
            >
              {config?.required ? (
                <>
                  {label}
                  &nbsp;<span className="text-red-500">*</span>
                </>
              ) : (
                label
              )}
            </label>
            <div className="cursor-pointer border border-gray-300 rounded-lg">
              <input
                id={fieldName}
                type="file"
                {...register(fieldName, config)}
                className="w-[280px]"
              />
            </div>
          </div>
          <img
            src="/svgs/Delete.svg"
            alt="delete"
            className="w-6 h-6 ml-2 cursor-pointer"
            onClick={() => deleteCustomField(_id)}
          />
          <img
            src="/svgs/Edit.svg"
            alt="edit"
            className="w-6 h-6 cursor-pointer ml-2 mr-4"
            onClick={() => {
              setIsEdit({
                id: _id,
                fieldName: fieldName,
                label: label,
                config: config,
                inputType: inputType,
                inputTypeLabel: inputType.replace(/\b\w/g, (match) =>
                  match.toUpperCase()
                ),
                options: options,
              });
              setOpen(true);
            }}
          />
        </div>
      );
    case "country":
      return <></>;
    case "state":
      return <></>;
    case "city":
      return <></>;
    default:
      return <input type="text" />;
  }
};
